import { render, staticRenderFns } from "./ProductHighlight.vue?vue&type=template&id=b1444fde&scoped=true"
import script from "./ProductHighlight.vue?vue&type=script&lang=ts"
export * from "./ProductHighlight.vue?vue&type=script&lang=ts"
import style0 from "./ProductHighlight.vue?vue&type=style&index=0&id=b1444fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1444fde",
  null
  
)

export default component.exports